import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card page--limited" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Dati utente", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "newusername" }, "Nome", -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "surname" }, "Cognome", -1)
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "email-off" }, "Email", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "icon_inside" }
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = { class: "icon_inside" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$router.back();}),
          icon: "pi pi-arrow-left",
          class: "p-mb-0"
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('back'),
            void 0,
            { bottom: true }
          ]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-mr-1",
          onClick: _ctx.onSave
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ])
      ])
    ]),
    (_ctx.me)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          autocomplete: "off",
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createVNode(_component_Fieldset, { class: "p-fluid" }, {
            legend: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_InputText, {
                    autocomplete: "off",
                    type: "text",
                    modelValue: _ctx.me.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.me.name = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_8
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_InputText, {
                    autocomplete: "off",
                    id: "surname",
                    type: "text",
                    modelValue: _ctx.me.surname,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.me.surname = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_InputText, {
                    autocomplete: "false",
                    id: "email-off",
                    type: "email",
                    modelValue: _ctx.me.email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.me.email = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_14
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_15
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_FloatLabel, { label: "Password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      autocomplete: "new-password",
                      id: "password",
                      type: _ctx.pwdType,
                      modelValue: _ctx.me.password,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.me.password = $event))
                    }, null, 8, ["type", "modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.pwdType === 'password')
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "pi pi-eye",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePwdType && _ctx.togglePwdType(...args)), ["exact"]))
                          }))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: "pi pi-eye-slash",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.togglePwdType && _ctx.togglePwdType(...args)))
                          }))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FloatLabel, { label: "Password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      autocomplete: "confirm-password",
                      id: "confirm-password",
                      type: _ctx.confirmPwdType,
                      modelValue: _ctx.confirmPassword,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmPassword = $event))
                    }, null, 8, ["type", "modelValue"]),
                    _createElementVNode("div", _hoisted_19, [
                      (_ctx.confirmPwdType === 'password')
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "pi pi-eye",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleConfirmPwdType && _ctx.toggleConfirmPwdType(...args)), ["exact"]))
                          }))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: "pi pi-eye-slash",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirmPwdType && _ctx.toggleConfirmPwdType(...args)))
                          }))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ], 32))
      : _createCommentVNode("", true)
  ]))
}